import { render, staticRenderFns } from "./EditRecurringDate.vue?vue&type=template&id=3878b704&scoped=true&"
import script from "./EditRecurringDate.vue?vue&type=script&lang=js&"
export * from "./EditRecurringDate.vue?vue&type=script&lang=js&"
import style0 from "./EditRecurringDate.vue?vue&type=style&index=0&id=3878b704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878b704",
  null
  
)

export default component.exports